export const visit = (vm, at) => {
at({ "sl": { "sanitizedEmail": { "imageError": "Ta slika je prevelika za prikaz.", "expandEmailButtonText": "Raz\u0161iri", "collapseEmailButtonText": "Strni", "hideEmailRepliesButtonText": "Skrij obrezano vsebino", "showEmailRepliesButtonText": "Ogled obrezane vsebine" } } });
};